import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import { DotsThreeVertical, Check } from '@phosphor-icons/react';
import '../dropdown/style';
import './style';

const Menu = (props) => {
  const {
    triggerIcon,
    menuItems,
    onClick,
    className,
    value,
    ...attr
  } = props;

  const [visible, setVisible] = useState(false);

  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  const getContent = () => (
    <div className={`menu-wrapper flex flex-col ${className}`}>
      {menuItems?.map((item, index) => (
        <>
          <div
            className="label-14 menu-item px-5 py-3 cursor-pointer flex items-center justify-between"
            onClick={(e) => {
              onClick(item, e);
              hide();
            }}
            key={item.label}
          >
            {item?.label}
            {(value && item?.value && value === item?.value) && (
              <Check size={24}
                color="#D92D20" />
            )}
          </div>
          {(index !== (menuItems?.length - 1)) && (<div className="divider w-full" key={item.label} />)}
        </>
      ))}
    </div>
  );

  return (
    <Tippy
      content={getContent()}
      allowHTML={true}
      interactive={true}
      visible={visible}
      onClickOutside={hide}
      className={`menu-popper ${className}`}
      placement="bottom-start"
      appendTo={() => document.body}
      {...attr}
    >
      <div
        className={`menu-trigger w-fit h-fit cursor-pointer visibility-${visible ? 'visible' : 'hidden'}`}
        onClick={visible ? hide : show}
      >
        {triggerIcon}
      </div>
    </Tippy>
  );
};

Menu.propTypes = {
  triggerIcon: PropTypes.node,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Menu.defaultProps = {
  triggerIcon: <DotsThreeVertical size={20}
    color="#101010" />,
  menuItems: [],
  onClick: () => null,
  className: '',
};

export default Menu;
